import { useCallback, useState } from "react";
import clinicAPI from "../services/clinicApi";
import { useToast } from "../components/ui";

function isRepostPost(post) {
  return Boolean(post?.repost_source || post?.repost_of_id);
}

export function postEditInitialText(post) {
  if (!post) return "";
  if (isRepostPost(post)) {
    const text = String(post.body || "").trim();
    if (!text || text === " " || text.startsWith("Поделился записью:")) {
      return "";
    }
    return text;
  }
  return String(post.body || "");
}

async function updateClientPost(post, payload) {
  if (post.scope === "wall") {
    return clinicAPI.updateWallPost(post.id, payload);
  }
  return clinicAPI.updateMyClubLifePost(post.id, payload);
}

async function deleteClientPost(post) {
  if (post.scope === "wall") {
    return clinicAPI.deleteWallPost(post.id);
  }
  return clinicAPI.deleteMyClubLifePost(post.id);
}

export function useClientPostManage(setPosts) {
  const toast = useToast();
  const [menuPost, setMenuPost] = useState(null);
  const [editPost, setEditPost] = useState(null);
  const [busy, setBusy] = useState(false);

  const openMenu = useCallback((post) => setMenuPost(post), []);
  const closeMenu = useCallback(() => {
    if (!busy) setMenuPost(null);
  }, [busy]);

  const openEdit = useCallback((post) => {
    setMenuPost(null);
    setEditPost(post);
  }, []);

  const closeEdit = useCallback(() => {
    if (!busy) setEditPost(null);
  }, [busy]);

  const applyUpdatedPost = useCallback(
    (updated) => {
      if (!updated?.id) return;
      setPosts((prev) =>
        prev.map((p) => (p.id === updated.id ? { ...p, ...updated } : p)),
      );
    },
    [setPosts],
  );

  const removePost = useCallback(
    (postId) => {
      setPosts((prev) => prev.filter((p) => p.id !== postId));
    },
    [setPosts],
  );

  const confirmDelete = useCallback(
    async (post) => {
      if (!post || busy) return;
      setBusy(true);
      try {
        await deleteClientPost(post);
        removePost(post.id);
        setMenuPost(null);
        toast.success("Запись удалена");
      } catch (err) {
        toast.error(err.response?.data?.error || "Не удалось удалить");
      } finally {
        setBusy(false);
      }
    },
    [busy, removePost, toast],
  );

  const confirmEdit = useCallback(
    async (post, payload) => {
      if (!post || busy) return;
      setBusy(true);
      try {
        const data = await updateClientPost(post, payload);
        applyUpdatedPost(data.post);
        setEditPost(null);
        toast.success("Запись обновлена");
      } catch (err) {
        toast.error(err.response?.data?.error || "Не удалось сохранить");
      } finally {
        setBusy(false);
      }
    },
    [applyUpdatedPost, busy, toast],
  );

  return {
    menuPost,
    editPost,
    busy,
    openMenu,
    closeMenu,
    openEdit,
    closeEdit,
    confirmDelete,
    confirmEdit,
  };
}
